import { Box, useTheme } from '@mui/material';
import * as React from 'react';

interface FormWrapperProps {
  children?: any;
  sx?: any;
}

export const FormWrapper: React.FC<FormWrapperProps> = (props) => {
  const { children = null, sx = {} } = props;
  const theme = useTheme();

  return (
    <Box
      sx={{
        [theme.breakpoints.up('xs')]: {
          paddingX: 2,
          paddingY: 6,
        },
        [theme.breakpoints.up('sm')]: {
          paddingX: 4,
          paddingY: 6,
        },
        [theme.breakpoints.up('md')]: {
          paddingX: 8,
          paddingY: 8,
        },
        [theme.breakpoints.up('lg')]: {
          paddingX: 12,
          paddingY: 8,
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
